import { Box } from "@mui/material";

import { ArrowForward } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { useIsMobile } from "../../../../hooks/useIsMobile";
import { GoBackButton } from "./WizardFormWrapper";
import { SubmitButton } from "../SubmitButton";

const FormBox = styled("div")(({ theme }) => ({
    display: "flex",
    borderTop: `1px solid ${theme.palette.border?.light}`,
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        justifyContent: "space-between"
    },
    "& > section": {
        "&:first-of-type": {
            flex: 6,
            [theme.breakpoints.down("md")]: {
                flex: 1
            }
        },
        "&:last-of-type": {
            flex: 4,
            marginLeft: theme.spacing(2),
            [theme.breakpoints.down("md")]: {
                flex: 1,
                marginLeft: 0
            }
        }
    }
}));
export const WizardWithSummaryFormWrapper = ({ control, handleSubmit, buttonLabel, goBack, formFields, summary }) => {
    const isMobile = useIsMobile();
    const GoForward = <SubmitButton control={control} buttonLabel={buttonLabel} endIcon={<ArrowForward/>}/>;
    const GoBack = <GoBackButton control={control} goBack={goBack}/>;

    return (
        <form onSubmit={handleSubmit}>
            <FormBox>
                <section>
                    {formFields}
                    {!isMobile &&
                    <Box display="flex" alignItems="center" justifyContent="space-between" borderTop={1} borderColor="border.light" paddingTop={2}>
                        {GoBack}{GoForward}
                    </Box>}
                </section>

                <section>
                    {summary}
                    {isMobile &&
                    <Box sx={{ "& button": { marginTop: 2, width: "100%" } }}>
                        {GoForward}{GoBack}
                    </Box>}
                </section>

            </FormBox>
        </form>
    );
};
